import { DeviceState } from './types';

class OneSignalService {
  public static async getDeviceState(): Promise<DeviceState | undefined> {
    return { userId: '' };
  }
}

export default OneSignalService;
